export interface VoyageDataBioFuelPayload {
  fuelName: string
  consumedAtSea: number
  consumedAtPort: number
  lowerCalorificValue: number
  e: number
  isExist: boolean
}

export class VoyageHistoryPayload {
  id: string
  voyageNo: string
  fromDate: string
  toDate: string
  fromPort: string
  toPort: string
  hfoConsumedAtSea: number
  mgoConsumedAtSea: number
  lfoConsumedAtSea: number
  hfoConsumedAtPort: number
  mgoConsumedAtPort: number
  lfoConsumedAtPort: number
  transportWork: number
  distanceTravelled: number
  hoursUnderway: number
  timeAtSea: number
  cargoCarried: number
  cO2EmittedAtSea: number
  cO2EmittedAtPort: number
  eu: string
  status: string
  createdAt: string
  updatedAt: string
  createdByUserName: string
  updatedByUserName: string
  inputSource: string
  isEUAConsumed: boolean
  vesselId: string
  vesselName: string
  isEUASurrendered: boolean
  opsConsumed: number
  bioFuelConsumptions: VoyageDataBioFuelPayload[]

  constructor(params: Partial<VoyageHistoryPayload>) {
    this.id = params.id || ''
    this.voyageNo = params.voyageNo || ''
    this.fromDate = params.fromDate || ''
    this.toDate = params.toDate || ''
    this.fromPort = params.fromPort || ''
    this.toPort = params.toPort || ''
    this.hfoConsumedAtSea = params.hfoConsumedAtSea || 0
    this.mgoConsumedAtSea = params.mgoConsumedAtSea || 0
    this.lfoConsumedAtSea = params.lfoConsumedAtSea || 0
    this.hfoConsumedAtPort = params.hfoConsumedAtPort || 0
    this.mgoConsumedAtPort = params.mgoConsumedAtPort || 0
    this.lfoConsumedAtPort = params.lfoConsumedAtPort || 0
    this.transportWork = params.transportWork || 0
    this.distanceTravelled = params.distanceTravelled || 0
    this.hoursUnderway = params.hoursUnderway || 0
    this.timeAtSea = params.timeAtSea || 0
    this.cargoCarried = params.cargoCarried || 0
    this.cO2EmittedAtSea = params.cO2EmittedAtSea || 0
    this.cO2EmittedAtPort = params.cO2EmittedAtPort || 0
    this.eu = params.eu || ''
    this.status = params.status || ''
    this.createdAt = params.createdAt || ''
    this.updatedAt = params.updatedAt || ''
    this.createdByUserName = params.createdByUserName || ''
    this.updatedByUserName = params.updatedByUserName || ''
    this.inputSource = params.inputSource || ''
    this.isEUAConsumed = params.isEUAConsumed || false
    this.vesselId = params.vesselId || ''
    this.vesselName = params.vesselName || ''
    this.isEUASurrendered = params.isEUASurrendered || false
    this.opsConsumed = params.opsConsumed || 0
    this.bioFuelConsumptions = params.bioFuelConsumptions || []
  }
}

export class SaveVoyageDataPayload {
  bioFuels: VoyageDataBioFuelPayload[] = []
  vesselVoyageHistories: VoyageHistoryPayload[]

  constructor(bioFuels: VoyageDataBioFuelPayload[], data: VoyageData[]) {
    this.bioFuels = [...bioFuels]
    this.vesselVoyageHistories = data.map(
      item => new VoyageHistoryPayload(item)
    )
  }
}

export interface VoyageDataPortDetail {
  id: string
  name: string
  latitude: number
  longitude: number
  priceAdjustmentHSFO: number
  priceAdjustmentVLSFO: number
  priceAdjustmentLSMGO: number
  showOnGraph: boolean
  totalLift: number
  isParent: boolean
  isEuropean: boolean
  isEuropeanOuterMostRegions: boolean
  isConsumeDOatPort: boolean
  updatedAt: string
  unLoCode?: string
  flagId?: string
  hasBioFuels: boolean
}

export class VoyageData {
  surrenderedEUA: number
  destinationPortDetail: VoyageDataPortDetail
  departurePortDetail: VoyageDataPortDetail
  emissionTaxType: number
  voyageCategory: string
  totalCO2Emitted: number
  liabaleCO2EmittedAtSea: number
  liabaleCO2EmittedAtPort: number
  expectedEUA: number
  errorMessages: string
  bioFuelConsumptions: any[]
  vesselIMO: number
  customerName: string
  id: string
  voyageNo: string
  fromDate: string
  toDate: string
  fromPort: string
  toPort: string
  hfoConsumedAtSea: number
  mgoConsumedAtSea: number
  lfoConsumedAtSea: number
  hfoConsumedAtPort: number
  mgoConsumedAtPort: number
  lfoConsumedAtPort: number
  transportWork: number
  distanceTravelled: number
  isLocked: boolean
  hoursUnderway: number
  timeAtSea: number
  cargoCarried: number
  cO2EmittedAtSea: number
  cO2EmittedAtPort: number
  eu: string
  createdAt: string
  updatedAt: string
  createdByUserName: string
  isEUAConsumed: boolean
  vesselId: string
  vesselName: string
  isEUASurrendered: boolean
  opsConsumed: number
  selected: boolean

  constructor(params: Partial<VoyageData>) {
    Object.assign(this, params)
    this.selected = false
  }
}
